import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-process-completed',
  templateUrl: './process-completed.component.html',
  styleUrls: ['./process-completed.component.scss'],
})
export class ProcessCompletedComponent {

  /**
   * per il testo principale
   * di default viene tradotto il contenuto di mainTextVariable
   * se viene passato un parametro q alla rotta, viene tradotto il contenuto di mainTextVariable+q
   * esempio:
   * /process-completed?q=PASSWORD-RECOVERY
   * su EOBI viene cercata la label PROCESS-COMPLETED.MAIN.TEXTPASSWORD-RECOVERY
   */
  mainTextVariable = 'PROCESS-COMPLETED.MAIN.TEXT';
  mainText = '';
  mainTextCustom = null;

  constructor(
    private readonly _router: Router,
    private route: ActivatedRoute,
    private readonly translateService: TranslateService
  ){
    this.translateService.get(this.mainTextVariable).subscribe(value => this.mainText = value);
    this.route.queryParams.subscribe(params => {
      //console.log(params);
      if (params['q']){
        this.translateService.get(this.mainTextVariable+params['q']).subscribe(value => {
          if (!value.includes(this.mainTextVariable)) { 
            this.mainTextCustom = value
          } 
        });
      }
    });
  }

  goToLogin() {
    //this._router.navigate(['dashboard']);
  }
}